module.exports = __webpack_public_path__ + "static/media/calendarBlack.6e2e5b0e.svg";